import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function clickOnRemove(obj) {
    const category = GA_EVENTS.crossSellRemoveInfoLightBox.category;
    const action = GA_EVENTS.crossSellRemoveInfoLightBox.actions.clickOnRemove;
    const label = PageTypeFactory.getPageType();
    const value = obj.spinachId;

    setBehaviourEvent({ category, action, label, value });
}

function clickOnOk() {
    const category = GA_EVENTS.crossSellRemoveInfoLightBox.category;
    const action = GA_EVENTS.crossSellRemoveInfoLightBox.actions.clickOnOk;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function clickOnLearnMore() {
    const category = GA_EVENTS.crossSellRemoveInfoLightBox.category;
    const action = GA_EVENTS.crossSellRemoveInfoLightBox.actions.clickOnLearnMore;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function close() {
    const category = GA_EVENTS.crossSellRemoveInfoLightBox.category;
    const action = GA_EVENTS.crossSellRemoveInfoLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open(from) {
    const category = GA_EVENTS.crossSellRemoveInfoLightBox.category;
    const action = GA_EVENTS.crossSellRemoveInfoLightBox.actions.open;
    const label = `Opened from within ${from}`;

    setBehaviourEvent({ category, action, label });
}

export {
    clickOnRemove,
    clickOnOk,
    clickOnLearnMore,
    close,
    open
};
